import React from "react";
import "../designcss/whatwedo.css";

const Whatwedo = () => {
  return (
    <div className="whatwedo-wrapper">
      <section className="whatwedocontainer">
        <h1 className="wedo">What We Do</h1>

        <p className="halfpara">
          We offer a complete WhatsApp marketing solution designed to support
          emerging businesses. Our platform helps companies reach, engage, and
          communicate with their customers more effectively.
        </p>

        {/* BLUE BOX */}
        <div className="containerpoints">
          <div className="points-grid">
            <ul>
              <li>
                Deliver individual notifications, updates, and promotions
                through WhatsApp marketing software.
              </li>
              <li>
                Have all customer communication within a group team inbox with a
                good WhatsApp marketing tool. .
              </li>
              <li>Automate low-code and no-code workflows.</li>
            </ul>

            <ul>
              <li>Intelligently chat Route and tag conversation.</li>
              <li>
                Monitor performance and activity with real-time analysis and
                activity.
              </li>
            </ul>
          </div>
        </div>

        <p className="fullpara">
          Our WhatsApp marketing services are time-saving, efficient, and more
          effective, ensuring that businesses save time, work efficiently and
          provide more effective customer experiences.
        </p>
      </section>
    </div>
  );
};

export default Whatwedo;
